import { render, staticRenderFns } from "./MaterialSourceDetail.vue?vue&type=template&id=6a383884&scoped=true&"
import script from "./MaterialSourceDetail.vue?vue&type=script&lang=js&"
export * from "./MaterialSourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a383884",
  null
  
)

export default component.exports